import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Behöver jag eget kök 2026 för att få serveringstillstånd?";
const SHORT_ANSWER = "Nej. Från 1 juni 2026 är kravet på eget kök och varierat matutbud borttaget enligt prop. 2025/26:221.";

export const Route = createFileRoute("/fraga/behover-jag-eget-kok-2026")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Behöver jag eget kök 2026 för att få serverings…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Kommunen prövar fortfarande verksamhetens karaktär, säkerhet och ordning – men du behöver inte ha eget kök eller komplett meny. Det öppnar för cocktailbarer, vinbarer och kvällskoncept som tidigare nekats."}
      source={{ label: "Prop. 2025/26:221 – Slopat matkrav för serveringstillstånd", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/proposition/slopat-matkrav-for-serveringstillstand_hd03221/" }}
      extraSources={[]}
      deepGuide={{ to: "/nya-regler-serveringstillstand-2026", label: "Nya regler 2026 – fullständig genomgång" }}
      related={[{"to": "/fraga/far-jag-servera-utan-mat", "label": "Får jag servera alkohol utan att servera mat 2026?"}, {"to": "/fraga/vad-ar-stadigvarande-tillstand", "label": "Vad är ett stadigvarande serveringstillstånd?"}, {"to": "/fraga/vilka-dokument-kravs", "label": "Vilka dokument krävs i ansökan om serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Behöver jag eget kök 2026 för att få serveringstillstånd?" },
      { name: "description", content: "Nej. Från 1 juni 2026 är kravet på eget kök och varierat matutbud borttaget enligt prop. 2025/26:221." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/behover-jag-eget-kok-2026" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/behover-jag-eget-kok-2026" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/behover-jag-eget-kok-2026",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Behöver jag eget kök 2026 för att få serverings…", url: "https://alkoholprovet.se/fraga/behover-jag-eget-kok-2026" },
      ]),
    ],
  }),
});
